// Spanish strings for the customer login + portal demo, keyed by exact English source string.
export const ES_PORTAL = {
  // ---------- login: tabs & shared ----------
  "Sign in or create access": "Iniciar sesión o crear acceso",
  "I have an account": "Tengo una cuenta",
  "I'm new here": "Soy nuevo aquí",
  "Preview only. On the sign-in tab, any email and password will open the demo portal.": "Solo vista previa. En la pestaña de inicio de sesión, cualquier correo y contraseña abrirá el portal de demostración.",
  "We will never ask for your password by phone, text, or email. If someone does, hang up and call us at {phone}.": "Nunca le pediremos su contraseña por teléfono, mensaje de texto o correo electrónico. Si alguien lo hace, cuelgue y llámenos al {phone}.",

  // ---------- login: sign in ----------
  "Sign in to your policies": "Inicie sesión en sus pólizas",
  "View your coverage, download ID cards and certificates, check billing, and message your agent.": "Vea su cobertura, descargue tarjetas de identificación y certificados, revise su facturación y envíe mensajes a su agente.",
  "Forgot password": "Olvidé mi contraseña",
  "Sign in": "Iniciar sesión",
  "Enter your email above first, then tap Forgot password.": "Primero escriba su correo arriba y luego toque Olvidé mi contraseña.",
  "If that email has an account, a reset link is on its way. It expires in 30 minutes.": "Si ese correo tiene una cuenta, un enlace de restablecimiento va en camino. Expira en 30 minutos.",
  "Enter the email address on your policy.": "Escriba el correo electrónico registrado en su póliza.",
  "Enter your password.": "Escriba su contraseña.",
  "Check the fields below and try again.": "Revise los campos siguientes e intente de nuevo.",
  "no account yet": "aún sin cuenta",
  "If you hold a policy with us but haven't set up online access,": "Si tiene una póliza con nosotros pero no ha configurado su acceso en línea,",
  "create your account": "cree su cuenta",
  "If you're not a client yet,": "Si aún no es cliente,",
  "start with a quote": "empiece con una cotización",

  // ---------- login: sign up ----------
  "Set up your online access": "Configure su acceso en línea",
  "Online accounts are tied to a policy we've already issued, so we start by matching you to it. It takes a minute.": "Las cuentas en línea están vinculadas a una póliza que ya emitimos, así que empezamos por verificarla. Toma un minuto.",
  "1 — Find your policy": "1 — Encuentre su póliza",
  "Policy number": "Número de póliza",
  "Top right of your declarations page, or on your ID card.": "Arriba a la derecha de su página de declaraciones, o en su tarjeta de identificación.",
  "Last name, or business name on the policy": "Apellido, o nombre del negocio en la póliza",
  "ZIP code on the policy": "Código postal de la póliza",
  "2 — Create your login": "2 — Cree su acceso",
  "This becomes your username. Use the address we already have on file if you can.": "Este será su nombre de usuario. Use el correo que ya tenemos registrado si es posible.",
  "Create a password": "Cree una contraseña",
  "At least 10 characters": "Al menos 10 caracteres",
  "At least 10 characters. Longer beats complicated.": "Al menos 10 caracteres. Larga es mejor que complicada.",
  "Too short — keep going.": "Muy corta — siga escribiendo.",
  "Acceptable. A few more characters would be better.": "Aceptable. Unos caracteres más serían mejor.",
  "Good password.": "Buena contraseña.",
  "Strong password.": "Contraseña fuerte.",
  "Confirm password": "Confirme la contraseña",
  "Type it again": "Escríbala de nuevo",
  "I agree to the": "Acepto los",
  "terms of use": "términos de uso",
  "and the": "y la",
  "privacy policy": "política de privacidad",
  ", and I consent to receive policy documents and notices electronically.": ", y doy mi consentimiento para recibir documentos y avisos de póliza por medios electrónicos.",
  "Create my account": "Crear mi cuenta",
  "Enter the policy number from your declarations page.": "Escriba el número de póliza de su página de declaraciones.",
  "Enter the name as it appears on the policy.": "Escriba el nombre tal como aparece en la póliza.",
  "Five-digit ZIP, please.": "Código postal de cinco dígitos, por favor.",
  "That email address looks incomplete.": "Ese correo electrónico parece incompleto.",
  "Use at least 10 characters.": "Use al menos 10 caracteres.",
  "The two passwords don't match.": "Las dos contraseñas no coinciden.",
  "Please accept the terms to create an account.": "Acepte los términos para crear una cuenta.",
  "A few fields need fixing before we can create your account.": "Hay que corregir algunos campos antes de crear su cuenta.",
  "not a client yet": "aún no es cliente",
  "You don't need an account to get a quote.": "No necesita una cuenta para obtener una cotización.",
  "and we'll set up access once your policy is issued.": "y configuraremos su acceso cuando se emita su póliza.",

  // ---------- login: done ----------
  "Check your email": "Revise su correo",
  "We've sent a verification link to": "Enviamos un enlace de verificación a",
  "Click it to finish setting up your account. The link is good for 24 hours.": "Haga clic para terminar de configurar su cuenta. El enlace es válido por 24 horas.",
  "Nothing arrived? Look in spam, or call us at {phone} and we'll sort it out.": "¿No llegó nada? Revise el correo no deseado, o llámenos al {phone} y lo resolvemos.",
  "Continue to the demo portal": "Continuar al portal de demostración",
  "Back to sign in": "Volver a iniciar sesión",

  // ---------- portal: shell ----------
  "Demo data. This shows how a client portal is normally laid out — nothing here is a real policy.": "Datos de demostración. Así se organiza normalmente un portal de clientes — nada de esto es una póliza real.",
  "Welcome back, {name}": "Bienvenido de nuevo, {name}",
  "Last signed in {date}, a few minutes ago · Client since 2021 · Your agent: {agent}": "Último acceso el {date}, hace unos minutos · Cliente desde 2021 · Su agente: {agent}",
  "Sign out": "Cerrar sesión",
  "Portal sections": "Secciones del portal",
  "Overview": "Resumen",
  "My policies": "Mis pólizas",
  "Billing & payments": "Facturación y pagos",
  "Documents": "Documentos",
  "Claims": "Reclamos",
  "Certificates": "Certificados",
  "My profile": "Mi perfil",
  "Contact my agent": "Contactar a mi agente",
  "Demo only. In a live portal this action is handled by your agency management system.": "Solo demostración. En un portal real, esta acción la maneja el sistema de gestión de su agencia.",

  // ---------- portal: overview ----------
  "A payment is due April 1": "Hay un pago con vencimiento el 1 de abril",
  "$348.33 on your personal auto policy. This one isn't on autopay.": "$348.33 de su póliza de auto personal. Esta no está en pago automático.",
  "Go to billing": "Ir a facturación",
  "Personal auto renews in 21 days": "El auto personal se renueva en 21 días",
  "We're already re-shopping it. You'll get a comparison before it auto-issues.": "Ya la estamos re-cotizando. Recibirá una comparación antes de que se emita automáticamente.",
  "View policy": "Ver póliza",
  "Workers' comp payroll report is up to date": "El reporte de nómina de compensación laboral está al día",
  "Next report due July 15. Nothing needed from you right now.": "Próximo reporte el 15 de julio. No necesitamos nada de usted por ahora.",
  "Quick actions": "Acciones rápidas",
  "Request a certificate": "Solicitar un certificado",
  "Usually same business day": "Normalmente el mismo día hábil",
  "Report a claim": "Reportar un reclamo",
  "We'll track it with the adjuster": "Le daremos seguimiento con el ajustador",
  "Download ID cards": "Descargar tarjetas de identificación",
  "Auto policy, PDF": "Póliza de auto, PDF",
  "Request a policy change": "Solicitar un cambio de póliza",
  "Add a vehicle, driver, or location": "Agregar un vehículo, conductor o ubicación",
  "Set up autopay": "Configurar pago automático",
  "One policy isn't enrolled": "Una póliza no está inscrita",
  "Message my agent": "Enviar mensaje a mi agente",
  "Reply within one business day": "Respuesta en un día hábil",
  "Your coverage at a glance": "Su cobertura de un vistazo",
  "Business owner's policy": "Póliza de dueño de negocio",
  "Workers' compensation": "Compensación laboral",
  "Personal auto": "Auto personal",
  "Active": "Activa",
  "Renews soon": "Se renueva pronto",
  "$4,180 / yr": "$4,180 / año",
  "$2,940 / yr": "$2,940 / año",
  "$812 / 6 mo": "$812 / 6 meses",
  "Worth a conversation": "Vale la pena conversarlo",
  "Based on what you carry today, two gaps stand out. You have commercial auto exposure but no hired and non-owned coverage, and there's no umbrella sitting above your auto and general liability limits. Neither is urgent. Both are inexpensive.": "Según lo que tiene contratado hoy, destacan dos brechas. Tiene exposición de auto comercial pero sin cobertura de autos contratados y no propios, y no hay póliza paraguas por encima de sus límites de auto y responsabilidad civil general. Ninguna es urgente. Ambas son económicas.",
  "Ask about these": "Preguntar sobre esto",
  "Recent activity": "Actividad reciente",
  "Mar 4": "4 mar",
  "Mar 1": "1 mar",
  "Feb 20": "20 feb",
  "Feb 12": "12 feb",
  "Certificate issued to Westridge Property Group": "Certificado emitido a Westridge Property Group",
  "Payment of $348.33 received — autopay": "Pago de $348.33 recibido — pago automático",
  "Workers' comp audit worksheet added to Documents": "Hoja de auditoría de compensación laboral agregada a Documentos",
  "Vehicle added to personal auto policy": "Vehículo agregado a la póliza de auto personal",

  // ---------- portal: policies ----------
  "Three active policies. Open one to see limits and deductibles.": "Tres pólizas activas. Abra una para ver límites y deducibles.",
  "Coverage detail": "Detalle de cobertura",
  "Carrier": "Aseguradora",
  "Sample Carrier": "Aseguradora de Muestra",
  "Term": "Vigencia",
  "Annual premium": "Prima anual",
  "6-month premium": "Prima semestral",
  "Mar 1 – Mar 1": "1 mar – 1 mar",
  "Jan 15 – Jan 15": "15 ene – 15 ene",
  "Oct 1 – Apr 1": "1 oct – 1 abr",
  "Renews in 21 days": "Se renueva en 21 días",
  "General liability": "Responsabilidad civil general",
  "$1,000,000 per occurrence / $2,000,000 aggregate": "$1,000,000 por ocurrencia / $2,000,000 agregado",
  "Building": "Edificio",
  "Not covered — tenant policy": "No cubierto — póliza de inquilino",
  "Contents & equipment": "Contenidos y equipo",
  "$350,000 replacement cost": "$350,000 costo de reposición",
  "Business income": "Ingresos del negocio",
  "$500,000 · 12 months": "$500,000 · 12 meses",
  "Property deductible": "Deducible de propiedad",
  "Wind & hail deductible": "Deducible de viento y granizo",
  "2% of insured value": "2% del valor asegurado",
  "Additional insureds": "Asegurados adicionales",
  "Westridge Property Group (landlord)": "Westridge Property Group (arrendador)",
  "Employers liability": "Responsabilidad patronal",
  "Class codes": "Códigos de clase",
  "8810 clerical · 5183 plumbing": "8810 oficina · 5183 plomería",
  "Estimated payroll": "Nómina estimada",
  "Experience modifier": "Factor de experiencia",
  "Next payroll report": "Próximo reporte de nómina",
  "July 15": "15 de julio",
  "Bodily injury liability": "Responsabilidad por lesiones corporales",
  "Property damage": "Daños a la propiedad",
  "Uninsured motorist": "Conductor sin seguro",
  "Comprehensive / collision": "Cobertura amplia / colisión",
  "$500 deductible each": "$500 de deducible cada una",
  "Vehicles": "Vehículos",
  "Drivers": "Conductores",
  "Declarations page": "Página de declaraciones",
  "Full policy": "Póliza completa",
  "Request a change": "Solicitar un cambio",
  "Report payroll": "Reportar nómina",
  "ID cards": "Tarjetas de identificación",
  "Add or remove a vehicle": "Agregar o quitar un vehículo",
  "Add a driver": "Agregar un conductor",
  "Personal auto — add or remove a vehicle": "Auto personal — agregar o quitar un vehículo",
  "Personal auto — add a driver": "Auto personal — agregar un conductor",
  "I'd like to request a change to my {policy}: ": "Quisiera solicitar un cambio en mi {policy}: ",

  // ---------- portal: billing ----------
  "Next payment due April 1": "Próximo pago: vence el 1 de abril",
  "Personal auto policy PA-7730915. Premium is paid to the carrier that issued the policy — we don't take card payments.": "Póliza de auto personal PA-7730915. La prima se paga a la aseguradora que emitió la póliza — nosotros no cobramos con tarjeta.",
  "Pay on the carrier's portal": "Pagar en el portal de la aseguradora",
  "Set up autopay for this policy": "Configurar pago automático para esta póliza",
  "Autopay and delivery": "Pago automático y entrega",
  "Autopay — BOP-0042871": "Pago automático — BOP-0042871",
  "Drafted on the 1st from your business checking": "Se debita el día 1 de su cuenta corriente del negocio",
  "Autopay — WC-1190334": "Pago automático — WC-1190334",
  "Drafted on the 15th": "Se debita el día 15",
  "Autopay — PA-7730915": "Pago automático — PA-7730915",
  "Not enrolled. Billed manually each term.": "No inscrita. Se factura manualmente cada término.",
  "Paperless documents": "Documentos sin papel",
  "Policies and invoices by email instead of post": "Pólizas y facturas por correo electrónico en lugar de correo postal",
  "Payment history": "Historial de pagos",
  "Mar 1 — $348.33": "1 mar — $348.33",
  "Feb 15 — $245.00": "15 feb — $245.00",
  "Feb 1 — $348.33": "1 feb — $348.33",
  "Jan 15 — $245.00": "15 ene — $245.00",
  "Personal auto · paid by autopay": "Auto personal · pagado por pago automático",
  "Workers' comp · paid by autopay": "Compensación laboral · pagado por pago automático",
  "BOP · paid by autopay": "BOP · pagado por pago automático",
  "Receipt": "Recibo",
  "Got an audit invoice you don't understand?": "¿Recibió una factura de auditoría que no entiende?",
  "Workers' comp and general liability are audited after the term ends, and the extra bill is often a payroll classification issue rather than a real increase. Send it to us before you pay it.": "La compensación laboral y la responsabilidad civil general se auditan al terminar la vigencia, y el cobro extra suele ser un problema de clasificación de nómina más que un aumento real. Envíenosla antes de pagarla.",
  "Send it to my agent": "Enviarla a mi agente",

  // ---------- portal: documents ----------
  "Everything we've issued or received on your policies.": "Todo lo que hemos emitido o recibido sobre sus pólizas.",
  "Filter documents": "Filtrar documentos",
  "All": "Todos",
  "Declarations": "Declaraciones",
  "Audits & invoices": "Auditorías y facturas",
  "Declarations page — BOP-0042871": "Página de declaraciones — BOP-0042871",
  "Declarations page — WC-1190334": "Página de declaraciones — WC-1190334",
  "Auto ID cards — PA-7730915": "Tarjetas de auto — PA-7730915",
  "Certificate — Westridge Property Group": "Certificado — Westridge Property Group",
  "Certificate — City of Frisco permit office": "Certificado — Oficina de permisos de la Ciudad de Frisco",
  "Workers' comp audit worksheet — 2025": "Hoja de auditoría de compensación laboral — 2025",
  "Renewal proposal — personal auto": "Propuesta de renovación — auto personal",
  "PDF · added Mar 3": "PDF · agregado el 3 mar",
  "PDF · added Jan 18": "PDF · agregado el 18 ene",
  "PDF · added Oct 2": "PDF · agregado el 2 oct",
  "PDF · issued Mar 4": "PDF · emitido el 4 mar",
  "PDF · issued Apr 2": "PDF · emitido el 2 abr",
  "PDF · added Feb 20": "PDF · agregado el 20 feb",
  "PDF · added 4 days ago": "PDF · agregado hace 4 días",
  "Download": "Descargar",
  "Nothing filed under that category yet.": "Aún no hay nada archivado en esa categoría.",

  // ---------- portal: claims ----------
  "Hail damage — commercial roof": "Daño por granizo — techo comercial",
  "Open": "Abierto",
  "Claim number": "Número de reclamo",
  "Policy": "Póliza",
  "Date of loss": "Fecha de la pérdida",
  "Adjuster": "Ajustador",
  "Feb 26": "26 feb",
  "Assigned Mar 2": "Asignado el 2 mar",
  "Reported": "Reportado",
  "Adjuster assigned": "Ajustador asignado",
  "Inspection scheduled": "Inspección programada",
  "Mar 2": "2 mar",
  "Mar 14, 9:00 AM": "14 mar, 9:00 AM",
  "Estimate issued": "Estimado emitido",
  "Payment": "Pago",
  "Pending": "Pendiente",
  "We review the adjuster's estimate against your policy before you accept it. If the scope or valuation looks short, we push back.": "Revisamos el estimado del ajustador contra su póliza antes de que usted lo acepte. Si el alcance o la valuación se quedan cortos, lo cuestionamos.",
  "Upload photos or receipts": "Subir fotos o recibos",
  "Ask about this claim": "Preguntar sobre este reclamo",
  "Closed claims": "Reclamos cerrados",
  "Windshield — PA-7730915": "Parabrisas — PA-7730915",
  "Closed Aug 2025 · paid $312 · CLM-2025-01188": "Cerrado ago 2025 · pagado $312 · CLM-2025-01188",
  "View file": "Ver expediente",
  "Closed claims stay here for five years.": "Los reclamos cerrados permanecen aquí por cinco años.",
  "Report a new claim": "Reportar un nuevo reclamo",

  // ---------- portal: certificates ----------
  "Certificates of insurance": "Certificados de seguro",
  "Requests in before mid-afternoon usually go out the same business day.": "Las solicitudes recibidas antes de media tarde normalmente salen el mismo día hábil.",
  "Request a new certificate": "Solicitar un nuevo certificado",
  "Previously issued": "Emitidos anteriormente",
  "Issued Mar 4 · additional insured, waiver of subrogation · expires Mar 1": "Emitido el 4 mar · asegurado adicional, renuncia de subrogación · expira el 1 mar",
  "Issued Apr 2 · standard wording · expires Mar 1": "Emitido el 2 abr · redacción estándar · expira el 1 mar",
  "Issued Jan 9 · primary and non-contributory · expires Mar 1": "Emitido el 9 ene · primario y no contributivo · expira el 1 mar",
  "Reissue": "Reemitir",
  "All three expire when your BOP renews on March 1. We reissue them automatically — you don't need to ask.": "Los tres expiran cuando su BOP se renueva el 1 de marzo. Los reemitimos automáticamente — no necesita pedirlo.",

  // ---------- portal: profile ----------
  "Contact details": "Datos de contacto",
  "Name": "Nombre",
  "Business name": "Nombre del negocio",
  "Email": "Correo electrónico",
  "Phone": "Teléfono",
  "Mailing address": "Dirección postal",
  "Changing your mailing address here updates your file with us. It does not change the address on a policy — that's an endorsement, and we'll handle it with the carrier.": "Cambiar su dirección postal aquí actualiza su expediente con nosotros. No cambia la dirección en una póliza — eso es un endoso, y lo gestionamos con la aseguradora.",
  "How we contact you": "Cómo nos comunicamos con usted",
  "Renewal reminders": "Recordatorios de renovación",
  "60 and 30 days before each policy renews": "60 y 30 días antes de que se renueve cada póliza",
  "Payment reminders": "Recordatorios de pago",
  "Five days before a payment is due": "Cinco días antes del vencimiento de un pago",
  "Text messages": "Mensajes de texto",
  "Claim updates and urgent items only": "Solo actualizaciones de reclamos y asuntos urgentes",
  "Coverage newsletter": "Boletín de coberturas",
  "Occasional notes on Texas coverage changes": "Notas ocasionales sobre cambios de cobertura en Texas",
  "Security": "Seguridad",
  "Change password": "Cambiar contraseña",
  "Turn on two-factor authentication": "Activar autenticación de dos factores",
  "Sign out of all devices": "Cerrar sesión en todos los dispositivos",
  "Save changes": "Guardar cambios",
  "A 10-digit phone number, please.": "Un número de teléfono de 10 dígitos, por favor.",
  "Check the highlighted fields.": "Revise los campos marcados.",
  "Saved. Your contact details and preferences are up to date.": "Guardado. Sus datos de contacto y preferencias están al día.",

  // ---------- portal: agent ----------
  "Licensed Texas property & casualty agent · CPA · Individual NPN {npn}": "Agente de propiedad y accidentes con licencia de Texas · CPA · NPN individual {npn}",
  "Mon–Fri 8:30–5:30 CT": "Lun–Vie 8:30–5:30, hora del Centro",
  "What's this about?": "¿De qué se trata?",
  "Choose one": "Elija una opción",
  "A policy change": "Un cambio de póliza",
  "A billing or audit question": "Una pregunta de facturación o auditoría",
  "An open claim": "Un reclamo abierto",
  "A certificate request": "Una solicitud de certificado",
  "Adding a new coverage": "Agregar una nueva cobertura",
  "Something else": "Otra cosa",
  "Which policy?": "¿Cuál póliza?",
  "Not policy specific": "No es sobre una póliza específica",
  "BOP-0042871 — Business owner's policy": "BOP-0042871 — Póliza de dueño de negocio",
  "WC-1190334 — Workers' compensation": "WC-1190334 — Compensación laboral",
  "PA-7730915 — Personal auto": "PA-7730915 — Auto personal",
  "Your message": "Su mensaje",
  "Tell us what you need. If it's urgent, call instead — we'll always pick up faster than we type.": "Cuéntenos qué necesita. Si es urgente, mejor llame — siempre contestamos más rápido de lo que escribimos.",
  "Attach a document": "Adjuntar un documento",
  "A contract, an invoice, a photo of damage. Don't send Social Security numbers or card details here.": "Un contrato, una factura, una foto del daño. No envíe números de Seguro Social ni datos de tarjetas por aquí.",
  "Send message": "Enviar mensaje",
  "We reply within one business day. Messages here don't bind or change coverage.": "Respondemos en un día hábil. Los mensajes aquí no vinculan ni cambian la cobertura.",
  "Pick a topic so it reaches the right desk.": "Elija un tema para que llegue al escritorio correcto.",
  "Tell us what you need.": "Cuéntenos qué necesita.",
  "A couple of fields need filling in.": "Faltan un par de campos por completar.",
  "Message sent. Sreenivas will reply within one business day — sooner if it's a claim.": "Mensaje enviado. Sreenivas responderá en un día hábil — antes si se trata de un reclamo.",
};
